import React, { useContext, useEffect, useMemo, useState } from "react";
import { SfrContext } from "../../SFR";
import "./SfrFilters.scss";
import { Autocomplete, Button, Chip, TextField } from "@mui/material";
import { ActiveAlarmsData } from "../../../Alarms/ActiveAlarms";
import { useImmer } from "use-immer";
import { FIXED_DROPDOWNS, FIXED_REACTIVE_DROPDOWNS_COF, getAllowedUserRoleIds, rectificationStatusDropdowns, REPORTING_TIME_RANGE } from "../Constants";
import { APP_BASE_URL, GET_ALL_USER, GET_DEVICE_TYPE_ASSET } from "../../../../Common/EndPoints";
import { useSelector } from "react-redux";
import { selectedCustomersIdsSelector, permittedCustomersSelector, selectedCustomersSelector } from "../../../../features/authentication/auth-slice";
import axios from "axios";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AutocompleteStationListPop } from "../../../AutocompleteStationListPop/AutocompleteStationListPop";
import { getParsedLocalStorage } from "../../../../Utils/storage-utils";
import { DateUtil } from "../Utils";
import { extractParsedDataFromPermissions } from "../../../../Utils/Utils";

function hasDropdownCuurentValue(ddList, ddValue) {
  let hasValue = false;
  ddList.forEach((dd) => {
    if (dd.id === ddValue?.id) {
      hasValue = true;
    }
  });

  return hasValue;
}

const getStrIdListFromOptions = (dd = []) => dd.map((obj) => obj.id).join(",")
const initialFilters = {
  zone_ids: [],
  div_ids: [],
  customer_ids: [],
}

function SfrFilters() {
  const searchParam = new URLSearchParams(document.location.search);
  const [searchParamJson, setSearchParamJson] = useState({});
  const allowedUserRoleIds = useMemo(() => getAllowedUserRoleIds(), []);

  const { updateSfrFilters } = useContext(SfrContext);
  const { selectedCustomersIdName = [] } = useContext(ActiveAlarmsData);
  const [filterState, setFilterState] = useImmer(initialFilters);
  const customerIdList = useSelector(selectedCustomersIdsSelector)
  const [deviceTypeList, setDeviceTypeList] = useState([]);
  // const permittedCustomers = useSelector(permittedCustomersSelector);
  // const selectedCustomers = useSelector(selectedCustomersSelector);

  const user_permissions = getParsedLocalStorage("permissions");
  const parsedPermissions = useMemo(() => {
    return extractParsedDataFromPermissions(user_permissions);
  }, []);

  const selectedCustomersList = useSelector(selectedCustomersSelector);
  const permittedCustomerIds = useMemo(() => {
    const _list = selectedCustomersList;
    if (!_list) return [];
    return _list.map((customer) => customer.customerId);
  }, [selectedCustomersList]);

  const zone_dd = useMemo(() => {
    return parsedPermissions.zones;
  }, []);

  const div_dd = useMemo(() => {
    let total_divs = parsedPermissions.divisions;
    if (filterState.zone_ids.length) {
      const ids = filterState.zone_ids.map((obj) => obj.id);
      total_divs = parsedPermissions.divisions.filter((div_obj) => ids.includes(div_obj.zone.id));
      const filtered_form_div_ids = filterState.div_ids.filter((selected_div_obj) => {
        return total_divs.find((obj) => obj.id === selected_div_obj.id);
      });
      setFilterState((prev) => {
        prev.div_ids = filtered_form_div_ids;
      });
    }

    return total_divs;
  }, [filterState.zone_ids]);

  const customer_dd = useMemo(() => {
    let filtered_stations = parsedPermissions.stations.filter((obj) => permittedCustomerIds.includes(obj.id));
    if (filterState.div_ids.length) {
      const selected_div_ids = filterState.div_ids.map((obj) => obj.id);
      filtered_stations = filtered_stations.filter((stationObj) => selected_div_ids.includes(stationObj.division.id));
    } else if (filterState.zone_ids.length) {
      const selected_zone_ids = filterState.zone_ids.map((obj) => obj.id);
      filtered_stations = filtered_stations.filter((stationObj) => selected_zone_ids.includes(stationObj.zone.id));
    }
    const filtered_form_stn_ids = filterState.customer_ids.filter((selected_stn_obj) => {
      return filtered_stations.find((obj) => obj.id === selected_stn_obj.id);
    });
    setFilterState((prev) => {
      prev.customer_ids = filtered_form_stn_ids;
    });
    return filtered_stations;
  }, [permittedCustomerIds, filterState.div_ids, filterState.zone_ids]);

  useEffect(() => {
    const param = {};
    (searchParam ?? {}).forEach((value, key) => {
      param[key] = value;
    });
    if (Object.keys(param).length > 0) {
      const createdFilterParamsFromUrl = {};
      if (param.assetTypeLabel && param.assetTypeId) {
        const deviceTypeValue = {
          value: param.assetTypeId,
          alias: param.assetTypeLabel,
        };
        createdFilterParamsFromUrl["deviceTypeIds"] = [deviceTypeValue];
        // handleChange("deviceTypeIds", [deviceTypeValue]);
      }
      if (param.stationId && param.stationLabel) {
        const selcetCustomerValue = {
          id: param.stationId,
          value: param.stationLabel,
        };
        createdFilterParamsFromUrl["filterCustomerId"] = [selcetCustomerValue];
        // handleChange("filterCustomerId", [selcetCustomerValue]);
      }
      if (param.departmentId && param.departmentLabel) {
        const selcetdeptValue = {
          id: param.departmentId,
          value: param.departmentLabel,
        };
        createdFilterParamsFromUrl["admistration_department"] = selcetdeptValue;

        // handleChange("admistration_department", [selcetdeptValue]);
      }
      if (Object.keys(createdFilterParamsFromUrl).length > 0) {
        Object.entries(createdFilterParamsFromUrl).forEach(([stateName, stateValue]) => {
          handleChange(stateName, stateValue)
        })

        setFilters({ ...filterState, ...createdFilterParamsFromUrl })
      }
    }
    // handleChange("filterCustomerId", [selcetCustomerValue]);

    // console.log("deviceTypeList", deviceTypeList)
  }, []);

  // const permittedCustomerIds = useMemo(() => {
  //   const _list = selectedCustomersIdName;
  //   if (!_list) return [];
  //   return _list.map((customer) => ({ id: customer.customerId, value: customer.customerName }));
  // }, [selectedCustomersIdName?.length]);

  // const permittedDepartments = useMemo(() => {
  //   let _permittedDepartments = [];
  //   // console.log("filterState?.filterCustomerId", filterState?.filterCustomerId);
  //   selectedCustomers.forEach((customer) => {
  //     if (customer.department) {
  //       if (filterState?.filterCustomerId?.length > 0) {
  //         if (!filterState?.filterCustomerId.some((filter) => filter.id === customer.customerId)) return;
  //       }
  //       const depts = customer.department.map((data) => {
  //         return {
  //           id: data.id,
  //           value: data.name,
  //         };
  //       });
  //       _permittedDepartments = [..._permittedDepartments, ...depts];
  //     }
  //   });
  //   return _permittedDepartments;
  // }, [selectedCustomers?.length, filterState?.filterCustomerId?.length]);

  useEffect(() => {
    // console.log("Selected Time Range -->", filterState.reportingRange);
    // console.log("From Time --> ", filterState.failureOnStartTs); //1696408200000
    // console.log("To Time --> ", filterState.failureOnEndTs); //1698409800000

    let fromTime = null;
    let toTime = null;
    let dateUtil = DateUtil();
    switch (filterState?.reportingRange?.id) {
      case "CURRENT MONTH":
        fromTime = dateUtil.currentMonthFirstDate().getTime();
        toTime = dateUtil.currentTime().getTime();
        break;
      case "PREVIOUS MONTH":
        fromTime = dateUtil.prevMonthFirstDate().getTime();
        toTime = dateUtil.prevMonthLastDate().getTime();
        break;
      case "CURRENT QUARTER":
        fromTime = dateUtil.currentQuarterFirstDate().getTime();
        toTime = dateUtil.currentTime().getTime();
        break;
      case "CURRENT HALF YEARLY":
        fromTime = dateUtil.currentHalfYearlyStartDate().getTime();
        toTime = dateUtil.currentTime().getTime();
        break;
      case "CURRENT YEAR":
        fromTime = dateUtil.currentYearStartDate().getTime();
        toTime = dateUtil.currentTime().getTime();
        break;
      case "CUSTOM DATE RANGE":
        fromTime = null;
        toTime = null;
        break;
      default:
        break;
    }

    setFilterState((prev) => {
      prev.failureOnStartTs = fromTime;
      prev.failureOnEndTs = toTime;
    });
  }, [filterState.reportingRange]);

  useEffect(() => {
    getDeviceTypes();
  }, [filterState?.filterCustomerId?.length]);

  // useEffect(() => {
  //   console.log("searchParamJson --> ", searchParamJson);
  //   console.log("1st Time Filter Customer ", filterState);
  //   setFilterState((draft) => {
  //     //draft.filterCustomerId = permittedCustomerIds.filter(item => item.id === searchParamJson.station);
  //     //draft.admistration_department = permittedDepartments.filter(item => item.value === searchParamJson.department);
  //     draft.deviceTypeIds = deviceTypeList.filter(item => item.id === searchParamJson.assetTypeId);
  //   });
  // }, [searchParamJson, permittedCustomerIds]);

  // useMemo(() => {
  //   console.log("2nd Time Filter Customer ", filterState);
  //   setFilterState((draft) => {
  //     draft.filterCustomerId = permittedCustomerIds.filter(item => item.id === searchParamJson.station);
  //     draft.admistration_department = permittedDepartments.filter(item => item.value === searchParamJson.department);
  //     draft.deviceTypeIds = deviceTypeList.filter(item => item.id === searchParamJson.assetTypeId);
  //   });
  //   //setSearchParamJson({});
  // },[deviceTypeList]);

  const getDeviceTypes = () => {
    let url = `${APP_BASE_URL}${GET_DEVICE_TYPE_ASSET}`;
    // if (MOCK_API.deviceType.isMock) {
    //   url = MOCK_API.deviceType.endPoint;
    // }
    const selectedCustomersInSfrFilter = filterState?.filterCustomerId ?? [];
    const filteredCustomers = selectedCustomersInSfrFilter.map((customer) => customer.id).toString();
    const params = {
      customerIdList: filteredCustomers.length > 0 ? filteredCustomers : null,
    };
    axios.get(url, { params }).then((res) => {
      // console.log("devTypeApi response", res);
      let deviceTypes = res.data.data.map((type) => {
        return {
          value: type.typeid,
          label: type.type,
          alias: type.label,
          departmentId: type.departmentId,
          subtype: type.subtype,
          categories: type.categories,
        };
      });
      setDeviceTypeList(deviceTypes);
    });
  };

  const getUsersList = useMemo(() => {
    if (filterState.filterCustomerId || customerIdList.length > 0) {
      let list = [];
      // let url = `${APP_BASE_URL}${GET_USER_LIST}`;
      let url = `${APP_BASE_URL}${GET_ALL_USER}`;
      let params = {
        customerIds: filterState?.filterCustomerId?.length > 0 ? filterState?.filterCustomerId?.map((customer) => customer.id).toString() : customerIdList.toString(),
        roleIdList: allowedUserRoleIds.toString()
      }
      axios.get(url, { params }).then((res) => {
        // console.log("users", res.data.data);
        let USERS = res.data.data
        USERS.forEach((user) => {
          list.push({ id: user.id, value: user.firstName + ' ' + user.lastName })
        })

        // console.log("list", list);
      });
      return list;
    } else {
      return []
    }

  }, [filterState.filterCustomerId]);

  const getCOFDropDowns = useMemo(() => {
    let COF_LIST = [];
    if (filterState?.departement) {
      COF_LIST = FIXED_REACTIVE_DROPDOWNS_COF[filterState?.departement?.value];
    }
    if (filterState?.failureCause && !hasDropdownCuurentValue(COF_LIST, filterState?.failureCause)) {
      setFilterState((prev) => {
        prev.failureCause = null;
      });
    }

    return COF_LIST;
  }, [filterState.departement]);

  const reportingRangeList = useMemo(() => {
    let RANGE_LIST = [];
    RANGE_LIST = REPORTING_TIME_RANGE;
    return RANGE_LIST;
  }, []);

  const setFilters = (filters) => {
    let params = {
      ...filters,
      status: filters?.status?.value ?? null,
      filterCustomerId:
        (filters.customer_ids && filters.customer_ids.length) ? getStrIdListFromOptions(filters.customer_ids) : getStrIdListFromOptions(customer_dd),
      repairedByIds: filters?.repairedByIds?.length > 0 ? filters?.repairedByIds?.map((user) => user.id)?.toString() : null,
      deviceTypeIds:
        filters?.deviceTypeIds?.length > 0 ? filters?.deviceTypeIds?.map((dev) => dev.value)?.toString() : null,
      departement: filters?.departement?.value ?? null,
      failureCause: filters?.failureCause?.value ?? null,
      admistration_department: filters?.admistration_department?.id ?? null,
    };
    delete params.zone_ids;
    delete params.div_ids;
    delete params.customer_ids;

    // console.log("dsgfdfh", params);
    updateSfrFilters(params);
  };

  const handleChange = (stateName, value) => {
    setFilterState((prev) => {
      prev[stateName] = value
    })
  }
  const system_options = useMemo(() => {
    const systems = getParsedLocalStorage("systems_list", []);
    return systems.map((system) => ({
      id: system.id,
      label: system.code,
    }));
  }, []);
  return (
    <div className="sfr-filters">
      {/* <Autocomplete
        size="small"
        className="filter-input auto-complete"
        multiple
        disableCloseOnSelect
        options={permittedCustomerIds}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Station" placeholder="Station" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(customer) => customer.value}
        value={filterState?.filterCustomerId ?? []}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.filterCustomerId = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      /> */}

      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        options={zone_dd ?? []}
        value={filterState.zone_ids || []}
        onChange={(_, newValue) => {
          handleChange(
            "zone_ids",
            newValue,
          );
        }}
        disableCloseOnSelect
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Zones" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        disableCloseOnSelect
        options={div_dd ?? []}
        value={filterState.div_ids || []}
        onChange={(_, newValue) => {
          handleChange(
            "div_ids",
            newValue,
          );
        }}
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Divisions" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        disableCloseOnSelect
        options={customer_dd ?? []}
        value={filterState.customer_ids || []}
        onChange={(_, newValue) => {
          handleChange(
            "customer_ids",
            newValue,
          );
        }}
        getOptionLabel={(opt) => opt.value}
        renderInput={(params) => <TextField {...params} label="Stations" />}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((option) => option?.value ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />

      <Autocomplete
        size="small"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        multiple
        disableCloseOnSelect
        className="filter-input auto-complete"
        options={system_options}
        value={filterState.systems || []}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.systems = newValue;
          });
        }}
        renderInput={(params) =>
          <TextField {...params} label="Systems" />
        }
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].label} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.label ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />


      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={rectificationStatusDropdowns}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Status" placeholder="Status" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(customer) => customer.value}
        value={filterState?.status ?? null}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.status = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        multiple
        options={getUsersList}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Repaired By" placeholder="Repared By" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(customer) => customer.value}
        value={filterState?.repairedByIds ?? []}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.repairedByIds = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
      />
      {/* <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={permittedDepartments}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Department" placeholder="Department" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(dept) => dept.value}
        value={filterState?.admistration_department ?? null}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.admistration_department = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
      /> */}
      <Autocomplete
        className="filter-input auto-complete deviceTypeAutocomplete"
        size="small"
        disablePortal
        id="combo-box-demo"
        disableCloseOnSelect
        value={filterState?.deviceTypeIds ?? []}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        //options={dropDowns.deviceTypeDD.filter(item => !filters.departmentId || item.departmentId === filters.departmentId.id)}
        options={deviceTypeList.filter(
          (item) =>
            !filterState.admistration_department || item.departmentId === filterState.admistration_department.id,
        )}
        getOptionLabel={(params) => {
          return params.alias;
        }}
        onChange={(_, newValue) => {
          handleChange("deviceTypeIds", newValue);
        }}
        renderInput={(params) => <TextField size="small" {...params} label="Asset Type" />}
        multiple
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].alias} {...getTagProps(0)} />
              {value.length > 1 && (
                <AutocompleteStationListPop title={value.map((stn) => stn?.alias ?? "").toString()}>
                  <Chip size="small" label={`+${value.length - 1}`} />
                </AutocompleteStationListPop>
              )}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={FIXED_DROPDOWNS.department}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Branch" placeholder="Branch" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(customer) => customer.value}
        value={filterState?.departement ?? null}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.departement = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={getCOFDropDowns}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Cause Of Failure" placeholder="Cause Of Failure" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(customer) => customer.value}
        value={filterState?.failureCause ?? null}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.failureCause = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
      />
      <Autocomplete
        size="small"
        className="filter-input auto-complete"
        options={reportingRangeList}
        renderInput={(params) => (
          <TextField className="filter-input" size="small" {...params} label="Failure Range" placeholder="Status" />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(item) => item.value}
        value={filterState?.reportingRange ?? null}
        onChange={(_, newValue) => {
          setFilterState((state) => {
            state.reportingRange = newValue;
          });
        }}
        renderTags={(value, getTagProps) => {
          return (
            <div>
              <Chip size="small" variant="outlined" label={value[0].value} {...getTagProps(0)} />
              {value.length > 1 && <Chip size="small" label={`+${value.length - 1}`} />}
            </div>
          );
        }}
      />
      {(filterState.reportingRange?.id ?? "") === "CUSTOM DATE RANGE" && (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          <DateTimePicker
            className="form-input dateTimeField"
            label={"Failure Time(From)"}
            value={filterState.failureOnStartTs ?? null}
            onChange={(newValue) => {
              if (Date.parse(newValue && newValue["$d"])) {
                let ts = newValue["$d"].getTime();
                handleChange("failureOnStartTs", ts);
              } else {
                if (newValue === null) {
                  handleChange("failureOnStartTs", newValue);
                }
              }
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
          <DateTimePicker
            className="form-input dateTimeField"
            label={"Failure Time(To)"}
            value={filterState.failureOnEndTs ?? null}
            onChange={(newValue) => {
              if (Date.parse(newValue && newValue["$d"])) {
                let ts = newValue["$d"].getTime();
                handleChange("failureOnEndTs", ts);
              } else {
                if (newValue === null) {
                  handleChange("failureOnEndTs", newValue);
                }
              }
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
        </LocalizationProvider>
      )}

      <Button
        variant="contained"
        onClick={() => {
          setFilters(filterState);
        }}
      >
        Filter
      </Button>
      <Button
        variant="outlined"
        onClick={() => {
          setFilterState(initialFilters);
          setFilters({});
        }}
      >
        Clear
      </Button>
    </div>
  );
}

export default SfrFilters;
